import React from "react";
import "../styles/TermsOfService.css";

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Service – Squarefeet Marble</h1>

      <section>
        <h2>Overview</h2>
        <p>
          This website is operated by Squarefeet Marble. Throughout the site,
          the terms “we”, “us” and “our” refer to Squarefeet Marble. Squarefeet
          Marble offers this website, including all information, tools and
          services available from this site to you, the user, conditioned upon
          your acceptance of all terms, conditions, policies and notices stated
          here.
        </p>

        <p>
          By visiting our site and/or purchasing something from us, you engage
          in our “Service” and agree to be bound by the following Terms of
          Service (“Terms”), including additional terms, conditions and
          policies referenced herein.
        </p>
      </section>

      <section>
        <h2>Section 1 – Online Store Terms</h2>
        <p>
          By agreeing to these Terms of Service, you represent that you are at
          least the age of majority in your state or province of residence, or
          that you have given us your consent to allow any of your minor
          dependents to use this site.
        </p>

        <p>
          You may not use our products for any illegal or unauthorized purpose
          nor violate any laws in your jurisdiction.
        </p>

        <p>
          A breach or violation of any of the Terms will result in immediate
          termination of your Services.
        </p>
      </section>

      <section>
        <h2>Section 2 – General Conditions</h2>
        <p>
          We reserve the right to refuse service to anyone for any reason at any
          time.
        </p>

        <p>
          Credit card information is always encrypted during transfer over
          networks.
        </p>

        <p>
          You agree not to reproduce, duplicate, copy, sell, resell or exploit
          any portion of the Service without express written permission by us.
        </p>
      </section>

      <section>
        <h2>Section 3 – Accuracy, Completeness and Timeliness of Information</h2>
        <p>
          We are not responsible if information made available on this site is
          not accurate, complete or current. Any reliance on the material on
          this site is at your own risk.
        </p>
      </section>

      <section>
        <h2>Section 4 – Modifications to the Service and Prices</h2>
        <p>
          Prices for our products are subject to change without notice. We
          reserve the right to modify or discontinue the Service at any time.
        </p>
      </section>

      <section>
        <h2>Section 5 – Products or Services</h2>
        <p>
          Certain products or services may be available exclusively online and
          may have limited quantities subject to our Refund Policy.
        </p>
      </section>

      <section>
        <h2>Section 6 – Accuracy of Billing and Account Information</h2>
        <p>
          You agree to provide current, complete and accurate purchase and
          account information for all purchases made at our store.
        </p>
      </section>

      <section>
        <h2>Section 7 – Optional Tools</h2>
        <p>
          We provide access to third-party tools “as is” and “as available”
          without warranties or endorsements.
        </p>
      </section>

      <section>
        <h2>Section 8 – Third-Party Links</h2>
        <p>
          Third-party links may direct you to external websites. We are not
          responsible for examining or evaluating their content or accuracy.
        </p>
      </section>

      <section>
        <h2>Section 9 – User Comments, Feedback and Submissions</h2>
        <p>
          Any comments or submissions you send may be used by us without
          restriction or compensation.
        </p>
      </section>

      <section>
        <h2>Section 10 – Personal Information</h2>
        <p>
          Your submission of personal information through the store is governed
          by our Privacy Policy.
        </p>
      </section>

      <section>
        <h2>Section 11 – Errors, Inaccuracies and Omissions</h2>
        <p>
          We reserve the right to correct any errors, inaccuracies or omissions
          and to cancel orders if information is inaccurate.
        </p>
      </section>

      <section>
        <h2>Section 12 – Prohibited Uses</h2>
        <p>
          You are prohibited from using the site for any unlawful purpose,
          transmitting malicious code, or violating intellectual property
          rights.
        </p>
      </section>

      <section>
        <h2>Section 13 – Disclaimer of Warranties; Limitation of Liability</h2>
        <p>
          All services and products are provided “as is” without warranties of
          any kind. Use of the service is at your sole risk.
        </p>
      </section>

      <section>
        <h2>Section 14 – Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless Squarefeet Marble and its
          affiliates from any claim arising from your breach of these Terms.
        </p>
      </section>

      <section>
        <h2>Section 15 – Severability</h2>
        <p>
          If any provision of these Terms is found unlawful or unenforceable,
          the remaining provisions shall remain in effect.
        </p>
      </section>

      <section>
        <h2>Section 16 – Termination</h2>
        <p>
          These Terms remain effective unless terminated by either you or us.
        </p>
      </section>

      <section>
        <h2>Section 17 – Entire Agreement</h2>
        <p>
          These Terms constitute the entire agreement between you and
          Squarefeet Marble regarding use of the Service.
        </p>
      </section>

      <section>
        <h2>Section 18 – Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the
          laws of India and jurisdiction of Kishangarh, Rajasthan.
        </p>
      </section>

      <section>
        <h2>Section 19 – Changes to Terms of Service</h2>
        <p>
          We reserve the right to update or modify these Terms at any time.
          Continued use of the Service constitutes acceptance of those changes.
        </p>
      </section>

      <section>
        <h2>Section 20 – Contact Information</h2>
        <p>
          <strong>Address:</strong> Squarefeet Marble, Makrana Road, Madanganj,
          Kishangarh, Rajasthan, India
        </p>
        <p>
          <strong>Phone:</strong> +91-9950999997
        </p>
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:squarefeetmarble@gmail.com">
            squarefeetmarble@gmail.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;
